import { Fragment, useEffect, useState } from "react";

import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { AutoComplete } from "primereact/autocomplete";
import { RadioButton } from "primereact/radiobutton";
import classNames from "classnames";

import { TenantClientService } from "../../danh-muc/khach-hang/TenantClientService";
import { MGateWayService } from "../../lich-su-truyen-nhan/MGateWayService";
import { TaxCodeService } from "../../bao-cao/trang-thai-mst/TaxCodeService";

import { ToastService } from "../../../AppToast";

import { InvoiceField } from "./Initial";
import { useDialogCrup } from "../../../shared/hooks/DialogCrup";
import { FormatDisplay } from "../../../shared/format";
import { SearchCMNDService } from "../../../service/SearchCMND";

export const Input = (props) => {
  const { item, getFormat, patchItem, setting, validators, gridType } = props;

  const { fieldName } = setting;

  const [options, setOptions] = useState([]);
  const [taxCodeStatus, setTaxCodeStatus] = useState(null);

  useEffect(() => {
    switch (fieldName) {
      case InvoiceField.CurrencyCode:
        break;
      default:
      // console.log(fieldName);
    }
  }, [setting]); // eslint-disable-line react-hooks/exhaustive-deps

  const searchTaxCodeTenant = () => {
    const { taxCode, code } = getValue();

    const validateTaxCode = (value) => {
      let patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
      if (value.length > 10) {
        patt =
          /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
      }
      const cccdRegex = /^[0-9]{3}[01]\d{2}\d{6}$/;
      if (value === "") return true;

      // Kiểm tra nếu là căn cước công dân (tối đa 12 ký tự)
      if (value.length <= 12 && value.length > 0) {
        // Chỉ validate khi đủ 12 ký tự
        if (value.length === 12) {
          return cccdRegex.test(value);
        }
        // Nếu chưa đủ 12 ký tự, chỉ kiểm tra là số
        return /^[0-9]+$/.test(value);
      }

      // Kiểm tra mã số thuế
      if (patt.test(value) === false) {
        return false;
      }
      const number =
        Number(value.charAt(0)) * 31 +
        Number(value.charAt(1)) * 29 +
        Number(value.charAt(2)) * 23 +
        Number(value.charAt(3)) * 19 +
        Number(value.charAt(4)) * 17 +
        Number(value.charAt(5)) * 13 +
        Number(value.charAt(6)) * 7 +
        Number(value.charAt(7)) * 5 +
        Number(value.charAt(8)) * 3;

      return 10 - (number % 11) === Number(value.charAt(9));
    };

    const isValidTaxCode = validateTaxCode(taxCode);

    if (taxCode.length === 12 && isValidTaxCode) {
      SearchCMNDService.get(taxCode)
        .then((data) => {
          if (data) {
            if (data.error) {
              ToastService.error(data.error);
            } else if (data.ho_ten) {
              setValue({
                code: code || "",
                taxCode: taxCode || "",
                name: data.ho_ten || "",
                address: data.dia_chi || "",
              });
            } else {
              ToastService.error("Không tìm thấy dữ liệu CCCD.");
            }
          }
        })
        .catch((error) => {
          ToastService.error("Lỗi khi tìm kiếm CCCD.");
        });
    } else if (isValidTaxCode) {
      // Gọi searchTaxCode (V1) trước
      MGateWayService.searchTaxCode(taxCode)
        .then((data) => {
          if (data) {
            const provinceName = data.dctstinhten
              ? data.dctstinhten.includes("TP")
                ? data.dctstinhten.replace("TP", "Thành phố")
                : `Tỉnh ${data.dctstinhten}`
              : "";

            setValue({
              code: code || "",
              taxCode: data.mst || "",
              name: data.tennnt || "",
              personContact: data.buyerDisplayName || "",
              address:
                `${data.dctsdchi}, ${data.dctsxaten}, ${provinceName}, Việt Nam` ||
                "",
            });
          } else {
            // Nếu V1 không có dữ liệu, thử V2
            MGateWayService.searchTaxCodeV2(taxCode)
              .then((v2Data) => {
                if (v2Data) {
                  setValue({
                    code: code || "",
                    taxCode: v2Data.buyerTaxCode || "",
                    name: v2Data.buyerLegalName || "",
                    personContact: v2Data.buyerDisplayName || "",
                    address: v2Data.buyerAddress || "",
                  });
                } else {
                  ToastService.error("Không tìm thấy dữ liệu");
                }
              })
              .catch((v2Error) => {
                ToastService.error("Lỗi khi tìm kiếm MST (V2).");
              });
          }
        })
        .catch((v1Error) => {
          // Nếu V1 lỗi, thử V2
          MGateWayService.searchTaxCodeV2(taxCode)
            .then((v2Data) => {
              if (v2Data) {
                setValue({
                  code: code || "",
                  taxCode: v2Data.buyerTaxCode || "",
                  name: v2Data.buyerLegalName || "",
                  personContact: v2Data.buyerDisplayName || "",
                  address: v2Data.buyerAddress || "",
                });
              } else {
                ToastService.error("Không tìm thấy dữ liệu");
              }
            })
            .catch((v2Error) => {
              ToastService.error("Lỗi khi tìm kiếm MST.");
            });
        });
    }
  };
  const {
    render: renderDialogTenantClient,
    getValue,
    setValue,
    create: createTenantClient,
  } = useDialogCrup({
    header: "Khách hàng",
    dataKey: "id",
    width: "60rem",
    fields: [
      {
        field: "code",
        header: "Mã khách hàng",
        required: true,
        uppercase: true,
        InputTextProps: { maxLength: 50 },
        className: "md:col-6",
      },
      {
        field: "taxCode",
        header: "Mã số thuế",
        InputTextProps: { maxLength: 14, validator: "taxCode" },
        className: "md:col-5",
      },
      {
        type: "custom",
        className: "md:col-1",
        body: (
          <div className="mt-4">
            <Button
              icon="pi pi-search"
              className="p-button-rounded p-button-outlined"
              onClick={searchTaxCodeTenant}
            />
          </div>
        ),
      },
      {
        field: "name",
        header: "Tên đơn vị",
        InputTextProps: { maxLength: 400 },
        className: "md:col-12",
      },
      {
        field: "personContact",
        header: "Người mua hàng",
        InputTextProps: { maxLength: 100 },
        className: "md:col-4",
      },
      {
        field: "buyerIdentityCard",
        header: "CCCD",
        InputTextProps: { maxLength: 12 },
        className: "md:col-4",
      },
      {
        field: "buyerBudgetUnitCode",
        header: "Mã đơn vị quan hệ ngân sách",
        InputTextProps: { maxLength: 7 },
        className: "md:col-4",
      },
      {
        field: "address",
        header: "Địa chỉ",
        InputTextProps: { maxLength: 400 },
        className: "md:col-12",
      },
      {
        field: "email",
        header: "Email",
        type: "email",
        InputTextProps: { maxLength: 50 },
        className: "md:col-6",
      },
      {
        field: "mobile",
        header: "Điện thoại",
        InputTextProps: { maxLength: 20 },
        className: "md:col-6",
      },
      {
        field: "bankAccount",
        header: "Số tài khoản",
        InputTextProps: { maxLength: 30 },
        className: "md:col-5",
      },
      {
        field: "bankName",
        header: "Tên ngân hàng",
        InputTextProps: { maxLength: 400 },
        className: "md:col-7",
      },
    ],
    createItem: (item) => {
      return TenantClientService.create(item);
    },
    refreshLazyData: (data) => {
      patchItem(setting.groupTypeCode, fieldName, data);
    },
  });

  const completeMethod = (event) => {
    switch (fieldName) {
      case InvoiceField.BuyerTaxCode:
        TenantClientService.getList({
          taxCode: event.query,
          MaxResultCount: 1000,
        }).then(({ items }) => {
          setOptions(items);
        });
        break;
      case InvoiceField.BuyerCode:
        TenantClientService.getList({
          code: event.query,
          MaxResultCount: 1000,
        }).then(({ items }) => {
          setOptions(items);
        });
        break;
      case InvoiceField.BuyerLegalName:
        TenantClientService.getList({
          name: event.query,
          MaxResultCount: 1000,
        }).then(({ items }) => {
          setOptions(items);
        });
        break;
    }
  };

  const searchTaxCode = () => {
    if (item[fieldName]) {
      const value = item[fieldName];

      // Hàm validateTaxCode để phân biệt CCCD và MST
      const validateTaxCode = (value) => {
        let patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
        if (value.length > 10) {
          patt =
            /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
        }
        const cccdRegex = /^[0-9]{4}\d{2}\d{6}$/;
        if (value === "") return true;

        // Kiểm tra nếu là căn cước công dân (tối đa 12 ký tự)
        if (value.length <= 12 && value.length > 0) {
          // Chỉ validate khi đủ 12 ký tự
          if (value.length === 12) {
            return cccdRegex.test(value);
          }
          // Nếu chưa đủ 12 ký tự, chỉ kiểm tra là số
          return /^[0-9]+$/.test(value);
        }

        // Kiểm tra mã số thuế
        if (patt.test(value) === false) {
          return false;
        }
        const number =
          Number(value.charAt(0)) * 31 +
          Number(value.charAt(1)) * 29 +
          Number(value.charAt(2)) * 23 +
          Number(value.charAt(3)) * 19 +
          Number(value.charAt(4)) * 17 +
          Number(value.charAt(5)) * 13 +
          Number(value.charAt(6)) * 7 +
          Number(value.charAt(7)) * 5 +
          Number(value.charAt(8)) * 3;

        return 10 - (number % 11) === Number(value.charAt(9));
      };

      // Kiểm tra xem là CCCD hay MST
      const isValidTaxCode = validateTaxCode(value);

      if (value.length === 12 && isValidTaxCode) {
        // Nếu là CCCD (12 ký tự và hợp lệ)
        SearchCMNDService.get(value)
          .then((data) => {
            if (data) {
              if (data.error) {
                ToastService.error(data.error);
              } else if (data.ho_ten) {
                patchItem(setting.groupTypeCode, fieldName, {
                  buyerLegalName: data.ho_ten,
                  buyerTaxCode: value,
                  buyerAddress: data.dia_chi || "",
                });
              } else {
                ToastService.error("Không tìm thấy dữ liệu CCCD.");
              }
            } else {
              MGateWayService.searchTaxCodeV2(value)
                .then((v2Data) => {
                  if (v2Data) {
                    if (v2Data.error) {
                      ToastService.error(v2Data.error);
                    } else if (v2Data.buyerTaxCode) {
                      const provinceName = v2Data.dctstinhten
                        ? v2Data.dctstinhten.includes("TP")
                          ? v2Data.dctstinhten.replace("TP", "Thành phố")
                          : `Tỉnh ${v2Data.dctstinhten}`
                        : "";
                      patchItem(setting.groupTypeCode, fieldName, {
                        buyerLegalName: v2Data.buyerLegalName,
                        buyerTaxCode: value,
                        buyerAddress: v2Data.buyerAddress,
                      });
                    } else {
                      ToastService.error("Không tìm thấy dữ liệu MST (V2).");
                    }
                  }
                })
                .catch((v2Error) => {
                  ToastService.error("Lỗi khi tìm kiếm MST (V2).");
                });
            }
          })
          .catch((v1Error) => {
            // Nếu V1 lỗi, thử V2
            MGateWayService.searchTaxCodeV2(value)
              .then((v2Data) => {
                if (v2Data) {
                  if (v2Data.error) {
                    ToastService.error(v2Data.error);
                  } else if (v2Data.buyerTaxCode) {
                    const provinceName = v2Data.dctstinhten
                      ? v2Data.dctstinhten.includes("TP")
                        ? v2Data.dctstinhten.replace("TP", "Thành phố")
                        : `Tỉnh ${v2Data.dctstinhten}`
                      : "";
                    patchItem(setting.groupTypeCode, fieldName, {
                      buyerLegalName: v2Data.buyerLegalName,
                      buyerTaxCode: value,
                      buyerAddress: v2Data.buyerAddress,
                    });
                  } else {
                    ToastService.error("Không tìm thấy dữ liệu MST (V2).");
                  }
                }
              })
              .catch((v2Error) => {
                ToastService.error("Lỗi khi tìm kiếm MST.");
              });
          });
      } else if (isValidTaxCode) {
        // Nếu là MST hợp lệ
        // Gọi searchTaxCode (V1) trước
        MGateWayService.searchTaxCode(value)
          .then((data) => {
            if (data) {
              if (data.error) {
                ToastService.error(data.error);
              } else if (data.mst) {
                const provinceName = data.dctstinhten
                  ? data.dctstinhten.includes("TP")
                    ? data.dctstinhten.replace("TP", "Thành phố")
                    : `Tỉnh ${data.dctstinhten}`
                  : "";
                patchItem(setting.groupTypeCode, fieldName, {
                  buyerLegalName: data.tennnt,
                  buyerTaxCode: value,
                  buyerAddress:
                    `${data.dctsdchi}, ${data.dctsxaten}, ${provinceName}, Việt Nam` ||
                    "",
                });
              } else {
                ToastService.error("Không tìm thấy dữ liệu MST.");
              }
            } else {
              // Nếu V1 không có dữ liệu, thử V2
              MGateWayService.searchTaxCodeV2(value)
                .then((v2Data) => {
                  if (v2Data) {
                    if (v2Data.error) {
                      ToastService.error(v2Data.error);
                    } else if (v2Data.buyerTaxCode) {
                      const provinceName = v2Data.dctstinhten
                        ? v2Data.dctstinhten.includes("TP")
                          ? v2Data.dctstinhten.replace("TP", "Thành phố")
                          : `Tỉnh ${v2Data.dctstinhten}`
                        : "";
                      patchItem(setting.groupTypeCode, fieldName, {
                        buyerLegalName: v2Data.buyerLegalName,
                        buyerTaxCode: value,
                        buyerAddress: v2Data.buyerAddress,
                      });
                    } else {
                      ToastService.error("Không tìm thấy dữ liệu MST (V2).");
                    }
                  }
                })
                .catch((v2Error) => {
                  ToastService.error("Lỗi khi tìm kiếm MST (V2).");
                });
            }
          })
          .catch((v1Error) => {
            // Nếu V1 lỗi, thử V2
            MGateWayService.searchTaxCodeV2(value)
              .then((v2Data) => {
                if (v2Data) {
                  if (v2Data.error) {
                    ToastService.error(v2Data.error);
                  } else if (v2Data.buyerTaxCode) {
                    const provinceName = v2Data.dctstinhten
                      ? v2Data.dctstinhten.includes("TP")
                        ? v2Data.dctstinhten.replace("TP", "Thành phố")
                        : `Tỉnh ${v2Data.dctstinhten}`
                      : "";
                    patchItem(setting.groupTypeCode, fieldName, {
                      buyerLegalName: v2Data.buyerLegalName,
                      buyerTaxCode: value,
                      buyerAddress: v2Data.buyerAddress,
                    });
                  } else {
                    ToastService.error("Không tìm thấy dữ liệu MST (V2).");
                  }
                }
              })
              .catch((v2Error) => {
                ToastService.error("Lỗi khi tìm kiếm MST.");
              });
          });
      } else {
        ToastService.error("Mã số không hợp lệ. Vui lòng kiểm tra lại.");
        return;
      }

      setTaxCodeStatus(null);

      // Chỉ kiểm tra trạng thái MST khi là MST hợp lệ
      // if (value.length !== 12 && isValidTaxCode) {
      //   TaxCodeService.get(value).then(data => {
      //     if (data?.tthai && data?.ten_tthai && !['00', '02', '04'].includes(data?.tthai)) {
      //       setTaxCodeStatus(<i>Hóa đơn có thể bị lỗi do MST <b style={{ backgroundColor: 'yellow' }}>{value}</b> có trạng thái <span style={{ color: 'red' }}>{data?.ten_tthai}</span>.</i>);
      //     }
      //   }).catch(() => {
      //   });
      // }
    }
  };

  let required = null;
  if (setting.required) {
    required = <span className="required">*</span>;
  }
  const className = classNames({
    "p-invalid": validators && validators[fieldName],
  });

  const inputProps = {
    value: item[fieldName],
    className,
    disabled: !setting.readOnly,
  };

  let _maxLength = setting.maxLength;
  switch (fieldName) {
    case InvoiceField.relatedTemplateCode:
      if (item[InvoiceField.relatedInvoiceType] === 1) {
        _maxLength = 1;
      } else {
        _maxLength = 11;
      }
      break;
    case InvoiceField.relatedInvoiceSerial:
      if (item[InvoiceField.relatedInvoiceType] === 1) {
        _maxLength = 6;
      } else {
        _maxLength = 6;
      }
      break;
  }

  const inputText = (
    <InputText
      id={fieldName}
      {...inputProps}
      onChange={(e) =>
        patchItem(setting.groupTypeCode, fieldName, e.target.value)
      }
      maxLength={_maxLength}
    />
  );

  let input;
  switch (fieldName) {
    case InvoiceField.InvoiceSerial:
      if (setting.options) {
        input = (
          <Dropdown
            {...inputProps}
            options={setting.options}
            onChange={(e) =>
              patchItem(setting.groupTypeCode, fieldName, e.value)
            }
          />
        );
      } else {
        input = inputText;
      }
      break;
    case InvoiceField.CurrencyCode:
      input = (
        <Dropdown
          {...inputProps}
          options={setting.options}
          optionLabel="code"
          onChange={(e) => patchItem(setting.groupTypeCode, fieldName, e.value)}
        />
      );
      break;
    case InvoiceField.paymentMethod:
    case InvoiceField.relatedInvoiceProperty:
    case InvoiceField.relatedInvoiceType:
    case InvoiceField.vatRateOverRevenue:
      input = (
        <Dropdown
          {...inputProps}
          options={setting.options}
          onChange={(e) => patchItem(setting.groupTypeCode, fieldName, e.value)}
        />
      );
      break;
    case InvoiceField.nonTaxZone:
    case InvoiceField.isDeductionNQ43:
      input = (
        <div className="flex flex-wrap gap-3">
          {setting.options?.map((option, index) => (
            <div key={index} className="flex align-items-center">
              <RadioButton
                inputId={`${option.value}`}
                name={fieldName}
                value={option.value}
                onChange={(e) =>
                  patchItem(setting.groupTypeCode, fieldName, e.value)
                }
                checked={inputProps.value === option.value}
              />
              <label htmlFor={`${option.value}`} className="ml-2">
                {option.label}
              </label>
            </div>
          ))}
        </div>
      );
      break;
    case InvoiceField.BuyerTaxCode:
      const taxCodeTemplate = (item) => {
        const labels = [];
        if (item.taxCode) {
          labels.push(item.taxCode);
        }
        if (item.name) {
          labels.push(item.name);
        }
        if (item.address) {
          labels.push(item.address);
        }
        return (
          <div style={{ width: "50rem", whiteSpace: "break-spaces" }}>
            {labels.join(" - ")}
          </div>
        );
      };
      const onTaxCodeChange = (e) => {
        if (e.value?.taxCode) {
          const tenantClient = e.value;
          patchItem(setting.groupTypeCode, fieldName, {
            buyerCode: tenantClient.code,
            buyerTaxCode: tenantClient.taxCode,
            buyerLegalName: tenantClient.name,
            buyerAddress: tenantClient.address,
            buyerEmail: tenantClient.email,
            buyerBankAccount: tenantClient.bankAccount,
            buyerBankName: tenantClient.bankName,
            buyerTel: tenantClient.mobile,
            buyerDisplayName: tenantClient.personContact,
          });
        } else {
          patchItem(setting.groupTypeCode, fieldName, e.value);
        }
      };
      input = (
        <div className="p-inputgroup">
          <AutoComplete
            {...inputProps}
            suggestions={options}
            completeMethod={completeMethod}
            field="taxCode"
            itemTemplate={taxCodeTemplate}
            onChange={onTaxCodeChange}
          />
          <span className="p-inputgroup-addon">
            <i className="pi pi-search" onClick={searchTaxCode} />
          </span>
        </div>
      );
      break;
    case InvoiceField.BuyerCode:
      const codeTemplate = (item) => {
        const labels = [];
        if (item.code) {
          labels.push(item.code);
        }
        if (item.name) {
          labels.push(item.name);
        }
        if (item.address) {
          labels.push(item.address);
        }
        return (
          <div style={{ width: "50rem", whiteSpace: "break-spaces" }}>
            {labels.join(" - ")}
          </div>
        );
      };
      input = (
        <div className="p-inputgroup">
          <AutoComplete
            {...inputProps}
            suggestions={options}
            completeMethod={completeMethod}
            field="name"
            itemTemplate={codeTemplate}
            onChange={(e) =>
              patchItem(setting.groupTypeCode, fieldName, e.value)
            }
          />
          <span className="p-inputgroup-addon">
            <i className="pi pi-plus" onClick={createTenantClient} />
          </span>
          {renderDialogTenantClient()}
        </div>
      );
      break;
    case InvoiceField.BuyerLegalName:
      const nameTemplate = (item) => {
        const labels = [];
        if (item.taxCode) {
          labels.push(item.taxCode);
        }
        if (item.name) {
          labels.push(item.name);
        }
        if (item.address) {
          labels.push(item.address);
        }
        return (
          <div style={{ width: "50rem", whiteSpace: "break-spaces" }}>
            {labels.join(" - ")}
          </div>
        );
      };
      const onNameChange = (e) => {
        if (e.value?.taxCode) {
          const tenantClient = e.value;
          patchItem(setting.groupTypeCode, fieldName, {
            buyerCode: tenantClient.code,
            buyerTaxCode: tenantClient.taxCode,
            buyerLegalName: tenantClient.name,
            buyerAddress: tenantClient.address,
            buyerEmail: tenantClient.email,
            buyerBankAccount: tenantClient.bankAccount,
            buyerBankName: tenantClient.bankName,
            buyerTel: tenantClient.mobile,
            buyerDisplayName: tenantClient.personContact,
          });
        } else {
          patchItem(setting.groupTypeCode, fieldName, e.value);
        }
      };
      input = (
        <AutoComplete
          {...inputProps}
          suggestions={options}
          completeMethod={completeMethod}
          field="name"
          itemTemplate={nameTemplate}
          onChange={onNameChange}
        />
      );
      break;
    default:
      switch (setting.dataType) {
        case "int32":
          const fractionDigits = getFormat(setting);
          input = (
            <InputNumber
              locale={FormatDisplay.locales}
              inputId={fieldName}
              {...inputProps}
              onChange={(e) =>
                patchItem(setting.groupTypeCode, fieldName, e.value)
              }
              minFractionDigits={fractionDigits}
              maxFractionDigits={fractionDigits}
            />
          );
          break;
        case "string":
          input = inputText;
          break;
        case "datetime":
          input = (
            <Calendar
              id={fieldName}
              {...inputProps}
              onChange={(e) =>
                patchItem(setting.groupTypeCode, fieldName, e.value)
              }
              dateFormat="dd/mm/yy"
            />
          );
          break;
        default:
          console.log(setting);
      }
  }

  if (gridType === "percent") {
    return (
      <Fragment>
        {fieldName === InvoiceField.BuyerTaxCode && taxCodeStatus}
        <label
          htmlFor={fieldName}
          className={`col-12 mb-2 md:mb-0`}
          style={{ width: setting.lableWidth + "%" }}
        >
          {setting.lable}
          {required}
        </label>
        <div className={`col-12`} style={{ width: setting.controlWidth + "%" }}>
          {input}
          {!!(validators && validators[fieldName]) && (
            <small className="text-red-500">{validators[fieldName]}</small>
          )}
        </div>
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        {fieldName === InvoiceField.BuyerTaxCode && taxCodeStatus}
        <label
          htmlFor={fieldName}
          className={`col-12 mb-2 md:col-${setting.lableWidth} md:mb-0`}
        >
          {setting.lable}
          {required}
        </label>
        <div className={`col-12 md:col-${setting.controlWidth}`}>
          {input}
          {!!(validators && validators[fieldName]) && (
            <small className="text-red-500">{validators[fieldName]}</small>
          )}
        </div>
      </Fragment>
    );
  }
};
